import styled from 'styled-components';
import { colors } from '@/styles';

export const Cell = styled.div`
  text-align: right;
  span.null-value {
    color: ${colors.secondary.lightGray3};
  }
`;

export const Details = styled.div`
  span.null-value {
    color: ${colors.secondary.lightGray3};
  }
`;

export const Header = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  .header-cell-name {
    text-align: right;
    flex: 1;
  }
  .header-cell-sort {
    flex: 0;
  }
`;

export const Value = styled.span<{ $value: string }>`
  display: inline-block;
  /* color: ${({ $value }) => ($value ? colors.primary.white : colors.primary.white)}; */
  background-color: ${({ $value }) => ($value ? colors.semantic.positive.light : colors.semantic.negative.light)};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $value }) => ($value ? colors.semantic.positive.dark : colors.semantic.negative.dark)};
  color: ${({ $value }) => ($value ? colors.semantic.positive.dark : colors.semantic.negative.dark)};
  padding: 0px 5px 1px !important;
  border-radius: 100px !important;
  min-width: 4em;
  line-height: 1.4em;
  text-align: center;
`;

export const NullValue = styled.span`
  display: inline-block;
  background-color: ${colors.secondary.lightGray1};
  color: ${colors.secondary.lightGray3};
  border-width: 1px;
  border-style: solid;
  border-color: ${colors.secondary.lightGray2};
  padding: 0px 5px 1px !important;
  border-radius: 100px !important;
  min-width: 4em;
  line-height: 1.4em;
  text-align: center;
`;
